const CANCEL_LOAN = 'CANCEL_LOAN'

export { CANCEL_LOAN }
